import * as React from 'react';
import {connect} from 'react-redux';
import * as selectors from '../selectors';
import {
    DisplayFeature,
    DisplayFeatureType,
    FeatureAttributeChange,
    SpecialAttribute,
    SidePositionEdit
} from '../domain';
import classNames = require('classnames');
import {
    CopyAttributeValue,
    copyAttributeValue,
    copyFeatures,
    CopyFeatures,
    copyFeatureWithTypePopup,
    CopyFeatureWithTypePopup,
    deleteSelectedFeatures,
    DeleteSelectedFeatures,
    enableEditFeatureGeometry,
    EnableEditFeatureGeometry,
    setCopyGeometryVisible,
    setCommentsModalVisible,
    sidepositionFromParents,
    SidepositionFromParents,
    updateSidePositions,
    UpdateSidePositions,
    setCreateObjectVisible,
    CopyAttributeValueToAllFeaturesOfType,
    copyAttributeValueToAllFeaturesOfType, EditAllLanes, UpdateAllSidePositions, editAllLanes, updateAllSidePositions,
} from "../../../actions/actions";
import FeaturesState from "../domain/FeaturesState";
import {AttributeModel} from "../../../../integration/representation/viewmodel";
import {AttributeType} from "../../../../integration/datacatalog/datacatalog-services";
import {showWarningOnce} from "tslint/lib/error";
import {
    allSidePositionsEqualRelativeToMeteringDirection,
    createSidePositionEdit, getSidePositionForFeatureRelativeToMeteringDirection,
} from "../../../../sidePositionUtilities";
import {Locational} from "../../../../integration/representation/feature";
import {getLanesForFeatureRelativeToMetering} from "../../../../laneUtilities";


interface MenuState {
    showConfirmDelete: boolean;
    showConfirmCopyToAll: boolean;
}

interface TagProps {
    doCloseMenu: Function;
}

interface DispactchProps {
    doCopyAllAttributes: CopyAttributeValueToAllFeaturesOfType;
    doCopyAllLanes: EditAllLanes;
    doCopyAllSidePositions: UpdateAllSidePositions;
    doCopyAttributeValue: CopyAttributeValue;
    doCopySelectedFeatures: CopyFeatures;
    doDeleteSelectedFeatures: DeleteSelectedFeatures;
    doEditGeometry: EnableEditFeatureGeometry;
    startCopyFeaturesWithGeometry: CopyFeatureWithTypePopup;
    doUpdateSidePositions: UpdateSidePositions;
    doCopySidepositionsFromParents: SidepositionFromParents;
    showCopyGeometryModal: () => void;
    openManyCommentsModal: () => void;
    openCreateObjectModal: () => void;
}

interface StateProps {
    focusedAttribute: AttributeModel;
    focusedFeature: DisplayFeature;
    numberOfRoadObjectsToUpdateWhenCopyToAll: number;
    focusedAttributeType: AttributeType;
    focusedSpecialAttribute: SpecialAttribute;
    selectedFeatures: DisplayFeature[];
    selectedEditableFeatures: DisplayFeature[];
    allEditableFeatures: DisplayFeature[];
    selectedFeatureType: DisplayFeatureType;
    userCanEditFeature: boolean;
    userCanCreateFeature: boolean;
    userCanDeleteManyComments: boolean;
}

type MenuProps = TagProps & StateProps & DispactchProps;

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        focusedFeature: selectors.focusedFeature(state),
        focusedAttribute: selectors.focusedAttribute(state),
        numberOfRoadObjectsToUpdateWhenCopyToAll: selectors.numberOfRoadObjectsToUpdateWhenCopyToAll(state),
        focusedAttributeType: selectors.focusedAttributeType(state),
        focusedSpecialAttribute: selectors.focusedSpecialAttribute(state),
        selectedFeatures: selectors.selectedFeatures(state),
        selectedEditableFeatures: selectors.selectedEditableFeatures(state),
        allEditableFeatures: selectors.allEditableFeatures(state),
        userCanEditFeature: selectors.userCanEditFeature(state),
        userCanCreateFeature: selectors.userCanCreateFeature(state),
        userCanDeleteManyComments: selectors.userCanDeleteManyComments(state),
        selectedFeatureType: selectors.selectedFeatureType(state)
    };
};

const mapDispatchToProps: DispactchProps = ({
    doCopyAllAttributes: copyAttributeValueToAllFeaturesOfType,
    doCopyAttributeValue: copyAttributeValue,
    doCopyAllLanes: editAllLanes,
    doCopyAllSidePositions: updateAllSidePositions,
    doCopySelectedFeatures: copyFeatures,
    doDeleteSelectedFeatures: deleteSelectedFeatures,
    doEditGeometry: enableEditFeatureGeometry,
    startCopyFeaturesWithGeometry: copyFeatureWithTypePopup,
    doUpdateSidePositions: updateSidePositions,
    doCopySidepositionsFromParents: sidepositionFromParents,
    showCopyGeometryModal: () => setCopyGeometryVisible(true),
    openManyCommentsModal: () => setCommentsModalVisible(true),
    openCreateObjectModal: () => setCreateObjectVisible(true)
});



class ToolsMenu extends React.Component<MenuProps, MenuState> {

    constructor(props: MenuProps) {
        super(props);
        this.state = {
            showConfirmDelete: false,
            showConfirmCopyToAll: false
        };
    }

    render() {
        const {
            focusedAttributeType,
            numberOfRoadObjectsToUpdateWhenCopyToAll,
            selectedFeatures,
            selectedFeatureType,
            userCanEditFeature,
            focusedFeature,
            focusedSpecialAttribute,
        } = this.props;

        const featureHasErrors = (focusedFeature?.issues?.errors?.length ?? 0) > 0;
        const someFeatureIsLocked = selectedFeatureType.isLocked || selectedFeatures.find(feature => feature.isLocked);
        const editableSpecialAttribute = focusedSpecialAttribute === 'SIDEPOSISJON';

        let multipleSidePositionsFocused = false;
        if (focusedSpecialAttribute === 'SIDEPOSISJON' && !allSidePositionsEqualRelativeToMeteringDirection(focusedFeature)) {
            multipleSidePositionsFocused = true;
        }

        const createAbstractObjectClasses = classNames({
            'menuElement': true
        });

        const copyToAllClasses = classNames({
            'menuElement': true,
            'disabled': featureHasErrors || !focusedFeature || (!focusedAttributeType && !editableSpecialAttribute)
                || !userCanEditFeature || selectedFeatureType.isLocked || multipleSidePositionsFocused,
            'confirm': this.state.showConfirmCopyToAll
        });

        const copyToAllConfirmClasses = classNames({
            'copy-to-all-confirm': true,
            'copy-to-all-confirm-visible': this.state.showConfirmCopyToAll
        });

        const copyToSelectedClasses = classNames({
            'menuElement': true,
            'disabled': featureHasErrors || !focusedFeature || (!focusedAttributeType && !editableSpecialAttribute) || selectedFeatures.length == 0 || !userCanEditFeature || someFeatureIsLocked || multipleSidePositionsFocused
        });

        const copyGeometryClasses = classNames({
            'menuElement': true,
            'disabled': selectedFeatures.length == 0 || !userCanEditFeature
        });

        const sidepositionFromParentClasses = classNames({
            menuElement: true,
            disabled: selectedFeatures.length == 0 || !selectedFeatures.some(feature => feature.locational) || !userCanEditFeature || someFeatureIsLocked
        });

        const deleteSelectedClasses = classNames({
            'menuElement': true,
            'disabled': selectedFeatures.length == 0 || !userCanEditFeature || someFeatureIsLocked,
            'confirm': this.state.showConfirmDelete
        });

        const deleteConfirmClasses = classNames ({
            'delete-confirm': true,
            'delete-confirm-visible': this.state.showConfirmDelete
        });

        const editGeometryClasses = classNames ({
            'menuElement': true,
            'disabled': selectedFeatures.length !== 1 || someFeatureIsLocked
        });

        const copyGeometry = classNames({
            'menuElement': true,
            'disabled': selectedFeatures.length === 0
        });

        const showManyComments = classNames({
            'menuElement': true,
            'disabled': !this.props.userCanDeleteManyComments
        });

        const datacatalogLinkClasses = classNames({
            'menuElement': true
        });

        return (
            <div className="toolsmenu df-grid-menu">
                <div className={createAbstractObjectClasses} onClick={(e) => this.clickCreateObject(e)}>Opprett objekt</div>
                <div className={copyToAllClasses} onClick={(e) => this.clickCopyToAllSelected(e)}>Kopier verdien til
                    alle vegobjekter
                    <div className={copyToAllConfirmClasses}>
                        <button className="btn btn-danger" onClick={(e) => this.clickConfirmCopyToAll(e)}
                        >
                            Kopier verdien
                            til {numberOfRoadObjectsToUpdateWhenCopyToAll} vegobjekt{numberOfRoadObjectsToUpdateWhenCopyToAll !== 1 && 'er'}
                        </button>
                    </div>
                </div>
                <div className={copyToSelectedClasses} onClick={(e) => this.clickCopyToSelected(e)}>Kopier verdien til valgte vegobjekter</div>
                <div className={copyGeometryClasses} onClick={(e) => this.clickCopyFeatures(e)}>Kopier valgte vegobjekter</div>
                <div className={sidepositionFromParentClasses} onClick={(e) => this.clickSidepositionFromParents(e)}>Kopier sideposisjon fra mor</div>
                <div className={copyGeometryClasses} onClick={(e) => this.clickCopyToOtherType(e)}>Kopier til annen objekttype</div>
                <div className={deleteSelectedClasses} onClick={(e) => this.clickDeleteSelected(e)}>Fjern vegobjekter fra kontrakten
                    <div className={deleteConfirmClasses}>
                        <button className="btn btn-danger" onClick={(e) => this.clickConfirmDelete(e)}
                        >Fjern {selectedFeatures.length} vegobjekt{selectedFeatures.length > 1 && 'er'} fra kontrakt</button>
                        <p>Dette påvirker ikke innhold i NVDB.</p>
                    </div>
                </div>
                <div className={editGeometryClasses} onClick={(e) => this.clickEditGeometry(e)}>Rediger geometri</div>
                <div className={copyGeometry} onClick={(e) => this.clickCopyGeometry(e)}>Kopier geometri til/fra {this.props.selectedFeatures.length > 1 ? "disse objektene" : "dette objektet"}</div>
                <div className={showManyComments} onClick={(e) => this.clickOpenShowManyComments(e)}>Vis valgte kommentarer</div>
                <div className={datacatalogLinkClasses} onClick={() => this.clickDatacatalog()}>Gå til vegobjekttype i NVDB datakatalog</div>
                <div className={datacatalogLinkClasses} onClick={() => this.clickSintefDatacatalog()}>Gå til vegobjekttype i Sintef datakatalog</div>
            </div >
        );
    }

    clickEditGeometry (event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        this.props.doEditGeometry(this.props.selectedFeatures[0].id);
        this.props.doCloseMenu();
    }

    clickCopyGeometry(event: React.MouseEvent<HTMLDivElement>) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        this.props.doCloseMenu();
        this.props.showCopyGeometryModal();
    }

    clickSidepositionFromParents (event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        this.props.doCopySidepositionsFromParents(this.props.selectedFeatures);
        this.props.doCloseMenu();
    }

    clickConfirmDelete (event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        this.props.doDeleteSelectedFeatures();
        this.props.doCloseMenu();
    }

    clickCopyFeatures(event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        this.props.doCopySelectedFeatures(this.props.selectedFeatures);
        this.props.doCloseMenu();
    }

    clickCopyToOtherType(event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        this.props.startCopyFeaturesWithGeometry();
        this.props.doCloseMenu();
    }

    clickDeleteSelected(event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        if (this.props.selectedFeatures.length == 0) return;
        this.setState({showConfirmDelete: !this.state.showConfirmDelete});
    }

    clickCopyToAllSelected(event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        this.setState({showConfirmCopyToAll: !this.state.showConfirmCopyToAll});
    }

    clickConfirmCopyToAll(event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        const {focusedFeature, focusedSpecialAttribute, focusedAttribute, doCloseMenu} = this.props;
        if (!focusedFeature) return;

        if(focusedSpecialAttribute === "SIDEPOSISJON") {
            this.props.doCopyAllSidePositions(focusedFeature.id, getSidePositionForFeatureRelativeToMeteringDirection(focusedFeature));
        } else if(focusedSpecialAttribute === "FELT") {
            this.props.doCopyAllLanes(focusedFeature.id, getLanesForFeatureRelativeToMetering(focusedFeature).join("#"));
        } else if(focusedAttribute) {
            this.props.doCopyAllAttributes(focusedFeature.id, focusedAttribute.typeId);
        }

        doCloseMenu();
    }

    clickCreateObject(event: React.MouseEvent) {
        if(this.isTargetDisabled(event)){
            return;
        }
        this.props.openCreateObjectModal();
        this.props.doCloseMenu();
    }

    clickCopyToSelected(event: React.MouseEvent) {
        if (this.isTargetDisabled(event)) {
            return;
        }
        const {focusedFeature, doCloseMenu, selectedEditableFeatures} = this.props;
        if (!focusedFeature || selectedEditableFeatures.length == 0) return;

        this.copyAttributeToFeatures(selectedEditableFeatures);
        doCloseMenu();
    }

    isTargetDisabled(event: React.MouseEvent) {
        return event.currentTarget.classList.contains('disabled');
    }

    copyAttributeToFeatures(features: DisplayFeature[]) {
        const {focusedFeature, focusedAttribute, focusedAttributeType, focusedSpecialAttribute, doUpdateSidePositions, doCopyAttributeValue} = this.props;

        if (focusedSpecialAttribute === "SIDEPOSISJON") {
            const selectedSidePositionRelativeToMeteringDirection = getSidePositionForFeatureRelativeToMeteringDirection(focusedFeature);
            const sidePositionEdits: SidePositionEdit[] = [];
            if (allSidePositionsEqualRelativeToMeteringDirection(focusedFeature)) {
                features.forEach(feature => {
                    feature.locational.locationals.forEach((locational: Locational) => {
                        const sidePositionEdit = createSidePositionEdit(locational, selectedSidePositionRelativeToMeteringDirection, feature);
                        sidePositionEdits.push(sidePositionEdit);
                    });
                })
                doUpdateSidePositions(sidePositionEdits);
            } else {
                showWarningOnce("Objektet " + focusedFeature.name + " har flere ulike sideposisjoner.");
            }
        } else {
            const value = focusedAttribute ? focusedAttribute.value : null;
            const updates = features.map(feature => {
                    const currentAttribute = feature.attributes.filter(attribute => attribute.typeId === focusedAttributeType.id)[0];
                    const currentValue = currentAttribute ? currentAttribute.value : '';
                    return new FeatureAttributeChange(feature.id, currentValue, value, focusedAttributeType.id, feature.typeId);
                }
            );
            doCopyAttributeValue(updates);
        }
    }

    clickOpenShowManyComments(e: React.MouseEvent<HTMLDivElement>) {
        if(this.isTargetDisabled(e)){
            return;
        }
        this.props.openManyCommentsModal();
        this.props.doCloseMenu();
    }

    clickDatacatalog() {
        const {doCloseMenu} = this.props;
        window.open(this.datacatalogUrl(), '_blank');
        doCloseMenu();
    }

    clickSintefDatacatalog() {
        const {doCloseMenu} = this.props;
        window.open(this.sintefDatacatalogUrl(), '_blank');
        doCloseMenu();
    }

    datacatalogUrl() {
        const typeId = this.props.selectedFeatureType.typeId;
        return `https://datakatalogen.atlas.vegvesen.no/#/${typeId}`;

    }

    sintefDatacatalogUrl() {
        const typeId = this.props.selectedFeatureType.typeId;
        return `https://www.vegvesen.no/nvdb/datakatalog/eksport/produktspesifikasjon/${typeId}.htm`;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolsMenu);
